// src/hooks/usePaymentKeys
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPaymentKeys } from '../../../store/new-visit/NewVisitThunk'

export const usePaymentKeys = () => {
  const dispatch = useDispatch()
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const paymentKeys = useSelector((state) => state.newVisitReducer.paymentKeys)

  useEffect(() => {
    if (!paymentKeys.ClientKey) {
      dispatch(getPaymentKeys())
    }
  }, [dispatch, paymentKeys.ClientKey])

  return paymentKeys
}
